var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#FBEFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 17H30M14 17V25.8002C14 26.9203 14 27.4801 14.218 27.9079C14.4097 28.2842 14.7155 28.5905 15.0918 28.7822C15.5192 29 16.079 29 17.1969 29H26.8031C27.921 29 28.48 29 28.9074 28.7822C29.2837 28.5905 29.5905 28.2842 29.7822 27.9079C30 27.4805 30 26.9215 30 25.8036V17M14 17V16.2002C14 15.0801 14 14.5196 14.218 14.0918C14.4097 13.7155 14.7155 13.4097 15.0918 13.218C15.5196 13 16.0801 13 17.2002 13H18M30 17V16.1969C30 15.079 30 14.5192 29.7822 14.0918C29.5905 13.7155 29.2837 13.4097 28.9074 13.218C28.4796 13 27.9203 13 26.8002 13H26M18 13H26M18 13V11M26 13V11M24.5 23H19.5",
    stroke: "#AB01AF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLeave);
export default __webpack_public_path__ + "static/media/dashboardLeave.1ea62715385b60b83e09bfc43a08f58b.svg";
export { ForwardRef as ReactComponent };